import React, {useMemo} from "react";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold me-2">{t('Ver', {version: process.env.REACT_APP_VERSION})}</span>{" "}
          <span className="text-muted font-weight-bold me-2">{today.toString()}</span> &copy;{" "}
          <a
            href="https://eviden.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Eviden
          </a>{"   "}
          <span className="text-muted font-weight-bold me-2">{t('Environment')}</span>{process.env.REACT_APP_ENVIRONMENT}{" "}
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          <a
            href="https://eviden.com/about-us/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pe-3 ps-0"
          >
            {t('About')}
          </a>
          <a
            href="https://eviden.com/contact-us/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link ps-3 pe-0"
          >
            {t('Contact')}
          </a>
        </div>
      </div>
    </div>
  );
}
